const birthdateInput = document.getElementById('Cart-note');
const checkoutButton = document.getElementById('checkout');

const getCookie = (name) => {
  const cookieName = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return '';
};

// Read the last birthdate from the cookie and set the input value
const lastBirthdate = getCookie('lastBirthdate');
if (lastBirthdate && lastBirthdate != '') {
  birthdateInput.value = lastBirthdate;
}

const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = name + '=' + value + ';expires=' + expires.toUTCString();
};

const validateBirthday = () => {
  let birthdate = birthdateInput.value;
  // Set the birthdate in the cookie to expire in 3 days
  setCookie('lastBirthdate', birthdate, 3);
  birthdate = new Date(birthdateInput.value);
  const currentDate = new Date();

  // Check if the input is valid
  if (isNaN(birthdate.getTime())) {
    checkoutButton.disabled = true;
    return;
  }

  // Calculate the age
  const ageMilliseconds = currentDate - birthdate;
  const ageDate = new Date(ageMilliseconds);
  const age = Math.abs(ageDate.getUTCFullYear() - 1970);

  // Enable or disable the button based on age
  if (age >= 21) {
    checkoutButton.disabled = false;
  } else {
    checkoutButton.disabled = true;
  }
};

// Set the max and min date values for the input
const currentDate = new Date();
const maxDate = currentDate.toISOString().split('T')[0];
const minDate = new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate()).toISOString().split('T')[0];
birthdateInput.max = maxDate;
birthdateInput.min = minDate;

// Add event listener to the input
birthdateInput.addEventListener('change', validateBirthday);
document.addEventListener('DOMContentLoaded', function () {
  validateBirthday();
});

const fieldDateOfBirth = document.getElementById('Cart-note');
const fieldStyle = window.getComputedStyle(fieldDateOfBirth);
let month_names = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

// use localized month names
if ( window.Intl && window.Intl.DateTimeFormat ) {
      try {
        var formatter = new window.Intl.DateTimeFormat([], { month: 'long', timeZone: 'UTC' });
        var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => {
          var mm = month < 10 ? '0' + month : month;
          return new Date('0000-' + mm + '-01T00:00:00+00:00');
        });
        month_names = months.map(date => formatter.format(date));
     } catch(e) {}
}

const dateWrapper = document.createElement('div');
dateWrapper.id = 'date-select-wrapper';
fieldDateOfBirth.after(dateWrapper);

const dateFieldDay = document.createElement('select');
const dateFieldMonth = document.createElement('select');
const dateFieldYear = document.createElement('select');

const dateFields = [dateFieldYear, dateFieldMonth, dateFieldDay];

// copy over styles from text input
if ( fieldStyle ) {
  var styleOptions = [ 'boxSizing', 'backgroundColor', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'height', 'font', 'verticalAlign' ];
  styleOptions.forEach( function( s ) {
    if ( fieldStyle[s] ) {
      dateFields.forEach( function( f ) {
        f.style[s] = fieldStyle[s];
      } );
    }
  });
}

const emptyDayOption = document.createElement('option');
emptyDayOption.value = '';
emptyDayOption.textContent = 'Day';
dateFieldDay.add(emptyDayOption);
const emptyMonthOption = document.createElement('option');
emptyMonthOption.value = '';
emptyMonthOption.textContent = 'Month';
dateFieldMonth.add(emptyMonthOption);
const emptyYearOption = document.createElement('option');
emptyYearOption.value = '';
emptyYearOption.textContent = 'Year';
dateFieldYear.add(emptyYearOption);

const dayOptions = [emptyDayOption];
for ( var i = 1; i <= 31; i++ ) {
  var newOption = document.createElement('option');
  newOption.value = ( i < 10 ? '0' : '' ) + i;
  newOption.textContent = i;
  dayOptions.push( newOption );
  dateFieldDay.add( newOption );
}

const monthOptions = [emptyMonthOption];
for ( var i = 0; i < month_names.length; i++ ) {
  var newOption = document.createElement('option');
  newOption.value = ( i < 9 ? '0' : '' ) + ( i + 1 );
  newOption.textContent = month_names[i];
  monthOptions.push(newOption);
  dateFieldMonth.add(newOption);
}

const yearEnd = new Date().getFullYear();
const yearStart = yearEnd - 120;
const yearOptions = [emptyYearOption];
for (var i = yearEnd; i >= yearStart; i--) {
  var newOption = document.createElement('option');
  newOption.value = i;
  newOption.textContent = i;
  yearOptions.push(newOption);
  dateFieldYear.add(newOption);
}

dateWrapper.appendChild(dateFieldDay);
dateWrapper.appendChild(dateFieldMonth);
dateWrapper.appendChild(dateFieldYear);

const dateChangeHandler = function() {
  // var day = parseInt( dateFieldDay.value, 10 );
  const month = parseInt( dateFieldMonth.value, 10 );
  const year = parseInt( dateFieldYear.value, 10 );
  let maxDays = 31;

  if ( month === 2 ) {
    const isLeapYear = ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)
    maxDays = isLeapYear ? 29 : 28;
  } else if ( [2, 4, 6, 9, 11].indexOf( month ) >= 0 ) {
    maxDays = 30;
  }

  dayOptions.filter(function( o, i ) {
    o.hidden = i > maxDays;
    if ( o.hidden && o.selected ) {
      emptyDayOption.selected = true;
    }
  });

  let allSet = true;
  dateFields.forEach(field => {
    const isEmpty = ! field.value;
    if ( isEmpty ) {
      allSet = false;
    }
    field.classList[isEmpty ? 'add' : 'remove']('show-placeholder');
  });

  if ( allSet ) {
    fieldDateOfBirth.value = dateFields.map(function(field) {
      return field.value;
    }).join('-');
    validateBirthday();
  } else {
    fieldDateOfBirth.value = '';
  }
};

// if the original input already has a value, set the selected options accordingly
if ( fieldDateOfBirth.value ) {
  const ymd = fieldDateOfBirth.value.split('-');
  yearOptions.filter(function(o) {
    if ( o.value === ymd[0]) {
      o.selected = true;
    }
  });
  monthOptions[parseInt(ymd[1], 10)].selected = true;
  dayOptions[parseInt(ymd[2], 10)].selected = true;
}

dateFieldDay.addEventListener( 'change', dateChangeHandler );
dateFieldMonth.addEventListener( 'change', dateChangeHandler );
dateFieldYear.addEventListener( 'change', dateChangeHandler );
dateChangeHandler();
